// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ButtonComponent_button__pobag {
  font-size: 16px;
  font-weight: 500;
  padding: 9px 16px;
  border-radius: 12px;
  color: #678aa1;
  background-color: #fff;
}

.ButtonComponent_button__pobag:hover {
  opacity: 0.9;
}

.ButtonComponent_button__pobag:disabled {
  opacity: 0.4;
}

.ButtonComponent_red__PU8-K {
  color: #ffffff;
  background-color: #c50303;
}

.ButtonComponent_blue__ym3gI {
  color: #ffffff;
  background-color: #55bbeb;
}

.ButtonComponent_green__TB32F {
  color: #ffffff;
  background-color: #11205e;
}

.ButtonComponent_grey__zNRrB {
  color: #ffffff;
  background-color: rgb(150, 150, 150);
}

.ButtonComponent_mainColor__3nFer{
  color: #ffffff;
  background-color: #2d5064;
}

`, "",{"version":3,"sources":["webpack://./src/shared/Ui/Buttons/ButtonComponent.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".button {\n  font-size: 16px;\n  font-weight: 500;\n  padding: 9px 16px;\n  border-radius: 12px;\n  color: #678aa1;\n  background-color: #fff;\n}\n\n.button:hover {\n  opacity: 0.9;\n}\n\n.button:disabled {\n  opacity: 0.4;\n}\n\n.red {\n  color: #ffffff;\n  background-color: #c50303;\n}\n\n.blue {\n  color: #ffffff;\n  background-color: #55bbeb;\n}\n\n.green {\n  color: #ffffff;\n  background-color: #11205e;\n}\n\n.grey {\n  color: #ffffff;\n  background-color: rgb(150, 150, 150);\n}\n\n.mainColor{\n  color: #ffffff;\n  background-color: #2d5064;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ButtonComponent_button__pobag`,
	"red": `ButtonComponent_red__PU8-K`,
	"blue": `ButtonComponent_blue__ym3gI`,
	"green": `ButtonComponent_green__TB32F`,
	"grey": `ButtonComponent_grey__zNRrB`,
	"mainColor": `ButtonComponent_mainColor__3nFer`
};
export default ___CSS_LOADER_EXPORT___;
